<template>

  <div v-if="materials.length === 0" class="rounded-lg bg-gray-50 border border-gray-200 p-2 text-gray-500 italic text-center">
    No Materials
  </div>
  <div v-else>
    <!-- Materials. -->
    <div class="flex border -mb-px border-gray-200 bg-blue-50 rounded-t-lg">
      <div class="flex-1 text-xs font-semibold px-2 py-2.5">Materials</div>
      <div class="w-40 -ml-px text-xs font-semibold px-2 py-2.5 text-left">Supplier</div>
      <div class="w-32 -ml-px text-xs font-semibold px-2 py-2.5 text-right">Price</div>
      <div class="w-32 -ml-px text-xs font-semibold px-2 py-2.5 text-right">Quantity</div>
      <div class="w-32 -ml-px text-xs font-semibold px-2 py-2.5 text-right">Total cost</div>
    </div>

    <estimates-old-page-material-row
        v-for="material in materials"
        :key="material.id"
        :item="material"
        @updated="updated"
    ></estimates-old-page-material-row>

    <!-- Total lines. -->
    <div class="border -mb-px border-gray-200 bg-blue-50 rounded-b-lg">
      <div class="flex text-right">
        <div class="flex-1 text-sm font-semibold px-2 py-1">Total:</div>
        <div class="w-32 -ml-px text-sm font-semibold px-2 py-1">{{ total | toCurrency }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import {sumBy} from 'lodash'

export default {
  props: {
    materials: Array,
    updated: Function,
  },
  computed: {
    total() {
      return sumBy(this.materials, 'price')
    },
  }
}
</script>
